export enum EditorMode {
  Create = 'CREATE',
  Edit = 'EDIT',
  Duplicate = 'DUPLICATE',
}
